import React from 'react'
import SkeltonCard from './SkeltonCard';

type AppProps={
    times:number;
}

const CardLoader = ({times}:AppProps) => {

    const renderLoader=()=>{
    let array= new Array(times).fill(0)
   
    let finalData= array.map((e)=>{
        return <SkeltonCard key={e}/>
    })
    return <div className='row'>{finalData}</div>;
    }
  return (
    <>
        {renderLoader()}
    </>
  )
}

export default CardLoader
